<script setup>
  import { useUserInfo } from '@/composables/useUserInfo';
  import menuItems from '@/config/menus/avatar-menu-items';
  import { useLayoutStore } from '@/stores/layout';
  import { router } from '@inertiajs/vue3';
  import { storeToRefs } from 'pinia';

  const { user } = useUserInfo();
  const layout = useLayoutStore();
  const { avatarMenu } = storeToRefs(layout);

  function clickHandler(item) {
    layout.closeAvatarMenu();
    switch (item.action) {
      case 'logout':
        layout.openLogoutDialog();
        break;
      case 'accountSettings':
        router.visit('/settings');
        break;
    }
  }

  function getIconClassName(iconName, iconType = 'solid') {
    return `fa-${iconType} fa-${iconName}`;
  }
</script>

<template>
  <v-menu
    v-model="avatarMenu"
    :close-on-content-click="false"
    location="bottom end"
    transition="scale-transition"
  >
    <template #activator="{ props: activatorProps }">
      <v-avatar v-bind="activatorProps" size="32" color="liv-app-bar-avatar-color" class="mx-3">
        <v-icon size="24">mdi-account</v-icon>
      </v-avatar>
    </template>

    <v-card min-width="300" elevation="5" class="mt-1 pa-3">
      <v-list>
        <v-list-item class="px-4 py-3">
          <template #prepend>
            <v-avatar size="40" color="liv-app-bar-title-color">
              <v-icon size="32">mdi-account</v-icon>
            </v-avatar>
          </template>
          <v-list-item-title class="text-h6 mb-1 text-liv-app-bar-title-color">
            {{ user.name }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-body-1 text-liv-app-bar-title-color">{{
            user.email
          }}</v-list-item-subtitle>
        </v-list-item>

        <v-divider />

        <template v-for="(item, index) in menuItems" :key="index">
          <v-divider v-if="item.divider" />
          <v-list-item
            v-else
            :title="item.title"
            @click="clickHandler(item)"
            class="cognito-navdrawer__item"
          >
            <template #prepend>
              <font-awesome-icon
                :icon="getIconClassName(item.icon, item.iconType)"
                fixed-width
                size="lg"
                class="pl-2 pr-5"
              />
            </template>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>
